import { stepColors } from './constants'

const MAX_BAR_WIDTH = 50 // the UOM that is using is in 'px' for react-chart-js-2

interface StepDuration {
  [key: string]: number[]
}

export const generateChartData = (
  labels: string[],
  stepsDurationList: StepDuration,
  minBarWidth: number
) => {
  const stepsDurationsDatasets = Object.keys(stepsDurationList).map((step: string, stepColorIndex: number) => ({
    maxBarThickness: MAX_BAR_WIDTH,
    barThickness: minBarWidth,
    label: step,
    backgroundColor: stepColors[stepColorIndex],
    data: stepsDurationList[step]
  }))

  return {
    labels,
    datasets: stepsDurationsDatasets
  }
}
